import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Amendment} from '../models/amendment.model';
import {MigratedPolicy, MigratedPolicyIdentity} from '../models/migrated-policy.model';
import {SearchQueryParams} from '../models/search-query-params.model';
import {mapSearchListResponse} from '../helpers/search.helper';

@Injectable()
export class MigratedPoliciesService {

    baseUrl = '/api/secured/migrated/policy';

    constructor(private http: HttpClient) {
    }

    getMigratedPoliciesList(props: SearchQueryParams) {
        return this.http
            .get(this.baseUrl, {params: props.getHttpParams(), observe: 'response'})
            .pipe(mapSearchListResponse<MigratedPolicyIdentity>(MigratedPolicyIdentity));
    }

    getMigratedPolicy(policyId: number) {
        return this.http.get<MigratedPolicy>(`${this.baseUrl}/${policyId}`);
    }

    migratedPolicyCancellation(policyId: number) {
        return this.http.post<Amendment>(`${this.baseUrl}/${policyId}/amendment/cancel`, {});
    }
}
